export default {"src":"/_next/static/media/icon_store_promo_tag.77606415.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};